import React from 'react';
import { Box, Typography, Container, Grid, Button } from '@mui/material';
import { Handshake, ArrowRight } from 'lucide-react';
import { gradients } from '../theme';
import FadeIn from './FadeIn';

const Partner: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'black',
        py: 12,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background Decor */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          right: -100,
          transform: 'translateY(-50%)',
          width: 500,
          height: 500,
          background: 'radial-gradient(circle, rgba(0, 242, 255, 0.04) 0%, transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(80px)',
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={8} alignItems="center">
          {/* Left Side: Title */}
          <Grid size={{ xs: 12, md: 5 }}>
            <FadeIn direction="right">
              <Box>
                <Typography
                  variant="overline"
                  sx={{ color: '#00f2ff', fontWeight: 600, letterSpacing: 2, mb: 2, display: 'block' }}
                >
                  COLLABORATION
                </Typography>
                <Typography
                  sx={{
                    ...gradients.primaryText,
                    fontSize: { xs: 48, md: 72 },
                    fontWeight: 700,
                    lineHeight: 1.1,
                    letterSpacing: '-1px',
                    mb: 2,
                  }}
                >
                  Partner With <br /> Bluecat
                </Typography>
              </Box>
            </FadeIn>
          </Grid>

          {/* Right Side: Content */}
          <Grid size={{ xs: 12, md: 7 }}>
            <FadeIn direction="left" delay={0.2}>
              <Box sx={{ borderLeft: '1px solid rgba(255,255,255,0.1)', pl: { xs: 0, md: 6 }, ml: { xs: 0, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Box sx={{ p: 1.5, borderRadius: '12px', backgroundColor: 'rgba(0, 242, 255, 0.1)', color: '#00f2ff' }}>
                    <Handshake size={32} />
                  </Box>
                  <Typography variant="h5" sx={{ color: 'white', fontWeight: 600 }}>
                    Trusted Recycling Partner
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    color: 'grey.300',
                    fontSize: { xs: 18, md: 22 },
                    fontWeight: 400,
                    lineHeight: 1.6,
                    mb: 4,
                    maxWidth: 600
                  }}
                >
                  Looking for a reliable catalytic converter recycling & precious-metal recovery partner in the UAE?
                  <br /><br />
                  <span style={{ color: 'grey.500', fontSize: '1rem' }}>
                    Bluecat Recycling delivers compliant, efficient, and sustainable solutions tailored to your automotive recycling needs.
                  </span>
                </Typography>

                <Button
                  variant="contained"
                  endIcon={<ArrowRight size={20} />}
                  sx={{
                    background: gradients.primary,
                    color: 'white',
                    px: 4,
                    py: 1.5,
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontSize: '1rem',
                    fontWeight: 600,
                    boxShadow: '0 4px 20px rgba(0, 242, 255, 0.25)',
                    '&:hover': {
                      boxShadow: '0 4px 30px rgba(0, 242, 255, 0.4)',
                      transform: 'translateY(-2px)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Let's drive sustainability together
                </Button>
              </Box>
            </FadeIn>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Partner;
